import { BigNumber } from '@0x/utils'
import { Asset, getCommon } from 'app-lib/assetUtils'
import React from 'react'
import { Icon, InputBasic, Slider } from 'ui-framework'

interface IStakeInputProps {
  id: string
  max: BigNumber
  onChange: (name: 'ooki' | 'vbzrx' | 'iooki' | 'slp_ooki_eth', value: number) => void
  value: string
  asset: Asset
}

export function InputStake(props: IStakeInputProps) {
  const { spriteLogo, displayName } = getCommon(props.asset)
  return (
    <div className="margin-bottom-2 pos-rel">
      <span className="stake-input__icon">
        <Icon name={spriteLogo} size={32} />
      </span>
      <label className="stake-input__label">{displayName}</label>
      <InputBasic
        id={props.id}
        name={props.id}
        className="stake-input__field"
        type="number"
        step="0.01"
        max={props.max.toFixed(2, 1)}
        title={props.value}
        value={props.value}
        onChange={props.onChange}
        onChangeEmit="name-value"
      />
      <div className="pos-rel">
        <Slider
          id={props.id}
          step={0.01}
          min={0}
          max={Number(props.max.toFixed(2, 1))}
          onChangeNameValue={props.onChange}
          name={props.id}
          value={Number(props.value)}
        />
      </div>
    </div>
  )
}

export default React.memo(InputStake)
